export enum CardStatus {
    ACTIVE='ACTIVE',
    BLOCKED='BLOCKED',
    CANCELLED='CANCELLED'
}